import CreditCardForm from './credit-card-form';

export default CreditCardForm;
